import { App, Plugin } from 'vue';
import TraceTail from '@tracetail/js';
import { TraceTailOptions } from './types';
import { TRACETAIL_KEY } from './injection-keys';

export const TraceTailPlugin: Plugin = {
  install(app: App, options: TraceTailOptions) {
    if (!options.apiKey) {
      console.error('[TraceTail] API key is required');
      return;
    }

    // Create TraceTail client instance
    const client = new TraceTail({
      apiKey: options.apiKey,
      timeout: options.config?.timeout ?? 5000
    });

    // Provide the client and options to all components
    app.provide(TRACETAIL_KEY, {
      client,
      options
    });

    // Add global property for Options API compatibility
    app.config.globalProperties.$tracetail = {
      client,
      getFingerprint: () => client.generateFingerprint(),
      track: (event: string, data?: any) => Promise.resolve({ success: true, event, data })
    };
  }
};